$(function () {
  $('.js-service-button').on('click', function(e) {
      let $this = $(this);
      let $parentBlock = $this.closest('.js-service');
      let $hiddenBlock = $parentBlock.find('.js-service-block');

      if ($parentBlock.hasClass('is-active')) {
        $parentBlock.removeClass('is-active');
        $hiddenBlock.slideUp();
      }
      else {
        $('.js-service').removeClass('is-active');
        $('.js-service-block').slideUp();
        $parentBlock.addClass('is-active');
        $hiddenBlock.slideDown();
      }
  });

  $('.js-service-open').on('click', function(e) {
      let $this = $(this);
      let $hiddenBlock = $this.next('.js-service-wrapper');

      if ($this.hasClass('is-active')) {
        $this.removeClass('is-active');
        $hiddenBlock.slideUp();
      }
      else {
        $this.addClass('is-active');
        $hiddenBlock.slideDown();
      }
  });
});



